import { useEffect } from 'react';
import axiosApi from '../../../api/daonAxios';

const ApkDownload = () => {
    useEffect(() => {
        const downloadApk = async () => {
            try {
                const url = "/oauth/download/apk";
                
                const res = await axiosApi.get(url, {
                    responseType: 'blob'
                });
                
                const blob = new Blob([res.data], { type: 'application/vnd.android.package-archive' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = 'CMC_PLUS.apk';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(downloadUrl);
                
                window.close();
            } catch (error) {
                console.error('다운로드 실패:', error);
                alert('다운로드에 실패했습니다.');
            }
        };
        
        downloadApk();
    }, []);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column'
        }}>
            <h2>파일 다운로드 중...</h2>
            <p>잠시만 기다려주세요.</p>
        </div>
    );
};

export default ApkDownload;